<script lang="ts" setup>
import CustomRouterView from "@/layouts/content/CustomRouterView.vue";
import Drawer from "@/layouts/drawer/Drawer.vue";
import DrawerLayout from "@/layouts/drawer/DrawerLayout.vue";
import { DrawerSelection } from "@/layouts/drawer/use-drawer-data";
import { useDrawerStore } from "@/stores";
import { useScreenSize } from "@soft-db/ui";

const { toggleDrawer } = useDrawerStore();
const { mdOrLower } = useScreenSize();

const router = useRouter();
const route = useRoute();
function changePage(selection: DrawerSelection) {
	if (selection.type === "site") {
		router.push({
			name: "integrity-sites-id",
			params: { id: selection.id },
			query: { ...route.query },
		});
	} else {
		router.push({
			name: "integrity-stations-id",
			params: { id: selection.id },
			query: { ...route.query },
		});
	}
	if (mdOrLower.value) {
		toggleDrawer();
	}
}

const drawerDefaultOpen = computed(() => {
	return route.name === "integrity-index";
});
</script>

<template>
	<DrawerLayout :forceOpen="drawerDefaultOpen">
		<template #drawer>
			<Drawer headers :objects="['site', 'station']" @click="changePage" />
		</template>
		<CustomRouterView />
	</DrawerLayout>
</template>
